export enum Logic {
  or = 'or',
  and = 'and',
}

export enum Sort {
  asc = 'asc',
  desc = 'desc',
}
